import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("button", {
        class: "[ JS_blueCtaButton ] buttonBase buttonGreen w-100 mt-1 strong",
        onClick: _cache[0] || (_cache[0] =
            //@ts-ignore
            (...args) => (_ctx.addProduct && _ctx.addProduct(...args)))
    }, " In den Warenkorb "));
}
